import { faGithub } from '@fortawesome/free-brands-svg-icons/faGithub';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
// import { faAngellist } from '@fortawesome/free-brands-svg-icons/faAngellist';
// import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
// import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://github.com/philipjohn05/',
    label: 'Github',
    icon: faGithub,
  },
  {
    link: 'https://www.linkedin.com/in/pjfaraon',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
  {
    link: 'https://www.youtube.com/@hucares_',
    label: 'YouTube',
    icon: faYoutube,
  },
  {
    link: 'https://tinyurl.com/philipjohnf',
    label: 'Facebook',
    icon: faFacebookF,
  },
  {
    link: 'https://www.instagram.com/pj_faraon/',
    label: 'Instagram',
    icon: faInstagram,
  },
];

export default data;
